import { useLanguage } from "@/i18n/LanguageContext";
import { cn } from "@/lib/utils";

const LANGS = ["en", "pl"];

export const LanguageToggle = ({ className }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      className={cn(
        "inline-flex rounded-full bg-white/5 border border-white/10 p-0.5",
        className
      )}
    >
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`language-toggle-${l}`}
          aria-pressed={lang === l}
          onClick={() => setLang(l)}
          className={cn(
            "px-3 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-wide transition-colors duration-200",
            lang === l
              ? "bg-cyan-300/90 text-slate-950"
              : "text-[hsl(var(--muted-foreground))] hover:text-white"
          )}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
